export default __webpack_public_path__ + "static/media/Tal_Hoover_AHV_In_Moms_We_Trust.1ee6908d.jpg";